// validator.js -- Simple form data validation


// Type checks done during validation.
// A prop value being checked can be defined to have a type. If not set in the schema, default type of 'string' is used.
// These are the types that are checked during validation.
const validTypes = ['string', 'number', 'array', 'object', 'boolean'];

// Takes array, removes duplicate elements of the array, returns deduped array maintaining orig order
function deDupe(arr) {
    if (!Array.isArray(arr)) {
        return;
    }
    var deduped = [];
    for (let i in arr) {
        if (deduped.includes(arr[i])) {
            continue;
        }
        deduped.push(arr[i]);
    }
    return deduped;
}


function isNumber(val) {
    if (typeof val === 'number' && isFinite(val)) return true; // e.g. 0/0 or 4/0
    if (typeof val === 'string') {
        val = val.trim();
        if (val === '') return false;
        //https://stackoverflow.com/questions/6449611/check-whether-a-value-is-a-number-in-javascript-or-jquery
        return !isNaN(+val) && isFinite(val)
    }
    return false;
}

function isArray(val) {
    if (typeof val === 'object' && Array.isArray(val)) {
        return true;
    }
    return false;
}

// function isObjectLiteral(val) {
//     var type = typeof val;
//     return val != null && type === 'object' && !isArray(val);
// }

// From _lodash
function getTag(value) {
    if (value == null) {
        return value === undefined ? '[object Undefined]' : '[object Null]'
    }
    return Object.prototype.toString(value)
}
// From _lodash
function isString(value) {
    const type = typeof value
    return type === 'string' || (type === 'object' && value != null && !Array.isArray(value) && getTag(value) == '[object String]')
}

// From _lodash -- modified slightly
// NOTE: if value is type array, this returns true ... just be aware!
function isObject(value) {
    const type = typeof value
    return value != null && type === 'object';
}


function trim(val) {
    if (isDefined(val) && isString(val)) {
        val = val.trim();
    }
    return val;
}

function isEmpty(val) {
    if (val === '' || val === undefined || val === null) {
        return true;
    }
    return false;
}

function isDefined(val) {
    return !isUndefined(val);
}

function isUndefined(val) {
    return val === undefined;
}

function isNull(val) {
    return val === null
}

// Set as value to Validator object helpers property.
// Useful since custom validation rules - which use these quite a bit - defined outside of this module's scope can access
// them via: validatorObjReference.helpers._desired_function() (e.g. trim(), etc.). The validation rule function signature 
// calls for the validator obj ref as a parameter.
var helpers = {
    trim,
    isEmpty,
    isDefined,
    isUndefined,
    isNull,
    isString,
    isNumber,
    isArray,
    isObject
}


// v: Validator object instance
// data: data obj of whose property values are being validated
function validateType(type, val, data, prop, v) {

    // Log a validation error related to the type (e.g. string, array, etc.) of prop value.
    function reportTypeError(type) {
        var propLabel = v.getPropLabel(prop);
        // var propLabel = v.propLabel[prop] !== undefined && v.propLabel[prop] !== null ? v.propLabel[prop] : prop;
        var errorMsg = `${propLabel} must be of type: ${type}`
        v.addError(prop, propLabel, errorMsg);
        v.errorFound = true;
    }

    type = type.toLowerCase();
    if (!validTypes.includes(type)) {
        console.error(
            'Error detected during validation: Validation Config Error: Invalid type detected: PROP:', prop, '|', 'TYPE:', type, '|',
            `Valid types are: ${validTypes.join(', ')}`);
        return;
    }

    // var val = data[prop];
    if (type === 'string') {
        if (isString(val)) {
            // console.log(val, 'is a string');
            return;
        }
        if (isNumber(val)) {
            // console.log(val, 'coerced to a string');
            data[prop] = val.toString();
            return;
        }
        // console.log('VALIDATION ERROR:', val, 'is NOT a string.')
        // v.rulesApi.errors.push(typeErrorMsg(type));
        // v.rulesApi.errorFound = true;
        reportTypeError(type);
        return;

    }

    //     If IS a number, move along.
    //      If NOT a number:
    //          If a string:
    //                 Convert to Number.
    //                 Check: Is it now a number?
    //                      If yes: Use that (reset the prop's value)
    //                  If not a number: report error
    //          All other types: report error.

    if (type === 'number') {
        // *** Do isString check FIRST (before isNumber) because 
        // with isNumber first, if val IS a string (e.g. '335'), 
        // isNumber will return true and then inside the if stmt, 
        // we do nothing but return, i.e we don't do the coercion to 
        // a number and reset the property's value. 
        if (isString(val)) {
            val = +val;
            if (isNumber(val)) {
                // console.log(val, 'coerced to a number');
                data[prop] = val;
                return;
            }
        }
        if (isNumber(val)) {
            // console.log(val, 'is a number');
            return;
        }
        // console.log('VALIDATION ERROR:', val, 'is NOT a number.')
        reportTypeError(type);
        return;
    }

    if (type === 'array') {
        if (Array.isArray(val)) {
            // console.log(val, 'is an array');
        } else {
            // console.log('VALIDATION ERROR:', val, 'is NOT an array.')
            reportTypeError(type);
            return;
        }
    }

    // *** >> !! >> Testing for object LITERAL, not other objects, e.g. functions, arrays, regex, null, etc.
    if (type === 'object') {
        if (isObject(val) && !Array.isArray(val)) {
            // console.log(val, 'is an object');
            return;
        } else {
            // console.log('VALIDATION ERROR:', val, 'is NOT an object.')
            reportTypeError(type);
            return;
        }
    }

    if (type === 'boolean') {
        if (val === true || val === false) {
            // console.log(val, 'is a boolean')
            return;
        } else {
            // console.log('VALIDATION ERROR:', val, 'is NOT a boolean.')
            reportTypeError(type);
            return;
        }
    }
}

// The rules API: Each validation rule defined.  The Validator object is below this.
var rules = {

    // v: Validator object reference

    // type: function (val, ruleObj, fieldId, dataObj, propName, v) {
    type: function (dataObj, propName, ruleObj, v) {
        var val = dataObj[propName];
        val = trim(val);
        var type = ruleObj.type ? ruleObj.type : 'string';
        validateType(type, val, dataObj, propName, v);
    },


    // this.rulesApi[validationRule](propValue, ruleObj, fieldId, validateThis, propName, this);
    // propose: this.rulesApi[validationRule](validateThis, propName, ruleObj, fieldId, this);

    // ruleObj: { required: 'The error message if value not valid' }
    // required: function (val, ruleObj) {
    required: function (dataObj, propName, ruleObj, v) {
        var val = dataObj[propName];
        val = trim(val);
        if (isEmpty(val)) {
            var errorMsg = ruleObj.required;
            v.addError(propName, v.getPropLabel(propName), errorMsg);
            v.errorFound = true;
        }
        // return this;
    },


    // Single value check
    is: function (dataObj, propName, ruleObj, v) {
        var {
            type
        } = ruleObj;
        if (type === 'array' || type === 'object') return;
        var val = dataObj[propName];
        val = trim(val);
        // Value to match in the rule *should* be same as the val type (esp w/doTypeCheck set to true)
        if (val !== ruleObj.is[0]) {
            var errorMsg = ruleObj.is[1];
            v.addError(propName, v.getPropLabel(propName), errorMsg);
            v.errorFound = true;
        }
    },

    // Single value check 
    isNot: function (dataObj, propName, ruleObj, v) {
        var {
            type
        } = ruleObj;
        if (type === 'array' || type === 'object') return;
        var val = dataObj[propName];
        val = trim(val);
        // Value to match in the rule *should* be same as the val type (esp w/doTypeCheck set to true)
        if (val === ruleObj.is[0]) {
            var errorMsg = ruleObj.is[1];
            v.addError(propName, v.getPropLabel(propName), errorMsg);
            v.errorFound = true;
        }
    },

    // matchProp: function (val, ruleObj, fieldId, dataObj) {
    matchProp: function (dataObj, propName, ruleObj, v) {
        var val = dataObj[propName];
        val = trim(val);
        var [otherProp, errorMsg] = ruleObj.matchProp;
        var otherPropVal = trim(dataObj[otherProp]);
        if (!isEmpty(val) && !isEmpty(otherPropVal)) {
            if (val !== otherPropVal) {
                v.addError(propName, v.getPropLabel(propName), errorMsg);
                v.errorFound = true;
            }
        }
    },


    // ruleObj: { min: [4,'The value must be at least 4 characters.'] }
    // min: function (val, ruleObj) {
    min: function (dataObj, propName, ruleObj, v) {
        var val = dataObj[propName];
        val = trim(val);
        // Only run check if there's actually a value of non-zero length to check - cleaner
        // overall error message this way, e.g. if value is 'required', NOT doing this
        // gives BOTH (want one message at a time on given field): 'xxx is required. xxx must have minimum length'
        if (val.length === 0) {
            return;
        }
        if (val.length < ruleObj.min[0]) {
            var errorMsg = ruleObj.min[1];
            v.addError(propName, v.getPropLabel(propName), errorMsg);
            v.errorFound = true;
        }
        // return this;
    },


    // ruleObj: { max: [4,'The value must be at most 4 characters.'] }
    // max: function (val, ruleObj) {
    max: function (dataObj, propName, ruleObj, v) {
        var val = dataObj[propName];
        val = trim(val);
        // Only run check if there's actually a value of non-zero length to check - cleaner
        // overall error message this way, e.g. if value is 'required', NOT doing this
        // gives BOTH (want one message at a time on given field): 'xxx is required. xxx must have minimum length'
        if (val.length === 0) {
            return;
        }
        if (val.length > ruleObj.max[0]) {
            var errorMsg = ruleObj.max[1];
            v.addError(propName, v.getPropLabel(propName), errorMsg);
            v.errorFound = true;
        }
        // return this;
    },


    // ruleObj: { cannotBe: { '-': 'A country must be selected.'
    //                        US: 'Select any country except the US.'

    //                      }
    //          }
    // cannotBe: function (val, ruleObj) {
    cannotBe: function (dataObj, propName, ruleObj, v) {
        var val = dataObj[propName];
        val = trim(val);
        if (val.length === 0) {
            return;
        }

        // cannotBe property of ruleObj can be an array or obj.
        // If array: Can be 2-element array where:
        //  1. First element is string, where each character is a disallowed character; or
        //  2. First element is an array where each element is a disallowed value.
        //  The 2nd element is the error message.
        // If obj: Each key is a disallowed value; each value is the error message for that value.
        if (Array.isArray(ruleObj.cannotBe)) {
            let cannotBeValues = ruleObj.cannotBe[0]
            if (!Array.isArray(cannotBeValues)) {
                cannotBeValues = cannotBeValues.split('');
            }

            if (cannotBeValues.includes(val)) {
                var errorMsg = ruleObj.cannotBe[1];
                v.addError(propName, v.getPropLabel(propName), errorMsg);
                v.errorFound = true;
            }
        } else { // else ruleObj.cannotBe must be an obj
            for (let k in ruleObj.cannotBe) {
                if (val === k) {
                    v.addError(propName, v.getPropLabel(propName), ruleObj.cannotBe[k])
                    v.errorFound = true;
                    break;
                }
            }
        }

    },


    // email: function (val, ruleObj) {
    email: function (dataObj, propName, ruleObj, v) {
        var val = dataObj[propName];
        val = trim(val);
        if (val.length === 0) {
            return;
        }
        // From: https://developer.mozilla.org/en-US/docs/Learn/HTML/Forms/Form_validation
        // As per the HTML5 Specification:
        // const emailRegExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        // -- Update 6/2020 --
        // https://stackoverflow.com/questions/50330109/simple-regex-pattern-for-email
        // var emailRegExp = /[a-z0-9\._%+!$&*=^|~#%'`?{}/\-]+@([a-z0-9\-]+\.){1,}([a-z]{2,16})/
        var emailRegExp = /[a-z0-9._%+!$&*=^|~#%'`?{}/-]+@([a-z0-9-]+\.){1,}([a-z]{2,16})/;
        var isValidEmail = emailRegExp.test(val);
        if (!isValidEmail) {
            var errorMsg = ruleObj.email;
            v.addError(propName, v.getPropLabel(propName), errorMsg);
            v.errorFound = true;
        }
    }

}




// Set the propsOrder prop of the Validator instance settings prop
// v: Reference to the Validator instance
// value: A string: Property name; or array: Array of prop names, all str values
function setPropsOrder(v, value) {
    if (Array.isArray(value)) {
        // Clean up the passed in array: Dedupe and allow only strings
        return setSetting(v, 'propsOrder', deDupe(value).filter(i => isString(i)));
    }
    // If string passed in, convert it to an array with the value as its one element
    if (isString(value)) {
        value = [value]
    } else {
        // If anything else (not an array, not a string) is passed in, convert it to an empty array
        value = []
    }
    setSetting(v, 'propsOrder', value);
}


// v: Reference to the Validator instance
function setSetting(v, settingName, value) {
    v.settings[settingName] = value;
}

var Validator = {

    settings: {

        // User-defined list of prop names (of the data obj) in the order of validation. Any prop listed that is NOT 
        // in the data obj being validated is ignored. Props set here are validated first in the given order; any props in 
        // the data obj NOT listed are filled in after in their defaul order (e.g. the order resulting from Object.keys() and/or for/in loop on the obj).
        propsOrder: [],

        // Enable/disable verbose mode in validation process: If true, console log validation activity.
        verbose: false,

        // Enable/disable type checking on each data obj property value.
        doTypeCheck: true

    },

    // Collect/store validation error messages. Populated during validation function as and when validation errors are detected.
    // Each element is a text value.
    errorMsgs: [],

    // Flag used by the validation function AND each validation rule function. The validation function implements this flag 
    // as part of its logic. 
    errorFound: false,

    started: false,
    completed: false,

    // Map prop name to its full "friendly" name, e.g. propLabel[fName] = 'First Name'
    propLabel: {},


    // User-defined validation rules.
    // Property set externally by caller/user.
    customRules: {},

    // Standard pre-defined validation rules defined top of file; could be set exernally by caller/user.
    rulesApi: rules,

    // helpers defined top of file
    helpers: helpers,


    config: function (settingName, value) {
        if (this.settings[settingName] !== undefined) { // only allow existing settings (props on the settings obj) to be set/updated
            setSetting(this, settingName, value);
            if (settingName === 'propsOrder') {
                setPropsOrder(this, value);
            }
        }
    },


    addError: function (prop, propLabel, errMsg) {
        // this.errorMsgs.push(errMsg);
        this.errorMsgs.push([prop, propLabel, errMsg]);
    },

    // addError: function (propLabel, errMsg) {
    //     // this.errorMsgs.push(errMsg);
    //     this.errorMsgs.push([propLabel, errMsg]);
    // },

    getPropLabel: function (prop) {
        return isDefined(this.propLabel[prop]) && !isNull(this.propLabel[prop]) ? this.propLabel[prop] : prop;
    },

    validateViaRules: function (validateThis, rules) {

        // console.log('VALIDATOR>>>>>>>>>>', this);
        // // console.log('the rules->', rules);
        // return;

        // In each prop's rule set, make 'type' be the first to be checked in the validation.
        function typeCheckFirst(arrayOfRuleNames) {
            var idx = arrayOfRuleNames.indexOf('type');
            if (idx > -1) {
                arrayOfRuleNames.splice(idx, 1)
            }
            arrayOfRuleNames.unshift('type')
        }


        // Generate and return props validation order.
        // Props listed in settings.propsOrder (set by caller) are priority props in that they  get checked first, in the 
        // order they are listed. All remaining props (if any: user may have only listed *some* props, or user listed ALL props) 
        // 'fall in' after those listed in settings.propsOrder, in their 'natural' order.
        // Finally, any prop in the propsOrder setting that is NOT a valid prop (i.e.does not exist on the validation rules object) is removed.
        function getPropsValidationOrder(v) {
            // return Object.keys(rules);
            var allPropsDefaultOrder = Object.keys(rules);
            var priorityOrderedProps = v.settings.propsOrder;
            // Take the difference of these arrays
            var remainingProps = allPropsDefaultOrder.filter(i => {
                return !priorityOrderedProps.includes(i)
            });
            return [...priorityOrderedProps, ...remainingProps].filter(i => allPropsDefaultOrder.includes(i));
        }

        // Ordered Property Names: If propsOrder setting here on the Validator obj is set (via caller who wants properties validated in a 
        // specific order and thus so ordered are error messages, e.g. to match up with order of fields on a form), use THAT as the order 
        // of props on the obj being validated. Otherwise, use the 'natural' default order specified by the keys of the rules object.
        // var orderedProperties = this.settings.propsOrder.length > 0 ? this.settings.propsOrder : Object.keys(rules);
        var orderedProperties = getPropsValidationOrder(this);
        // console.log('********* ORDERED PROPS ********', orderedProperties);

        // TO DO (?): If orderedProperties (set in config by caller) do not include ALL the props in the obj being tested,
        // ONLY those in the array are actually tested (duh) ... is that what we want? Or, better to order those we want, move them to the 
        // front, and have ALL REMAINING props behind those listed in config in their 'default' order ???



        orderedProperties.forEach(propName => {

            this.errorFound = false;

            //console.log('PROPNAME>>>>>>>>>>>>>', this)
            var ruleNames = Object.keys(rules[propName]);
            typeCheckFirst(ruleNames);
            // for (let ruleName in ruleNames) {
            //     console.log(ruleNames[ruleName])
            // }

            for (let ruleName in ruleNames) {

                // Because doing for/in on array (ruleNames); rulename is the index; the value
                // of each element is in ruleNames[rulename] 
                var validationRule = ruleNames[ruleName];

                if (validationRule === 'type' && !this.settings.doTypeCheck) {
                    continue;
                }


                var propValue = validateThis[propName];


                if (this.settings.verbose) {
                    console.log('PROP:', propName, '|', 'VALUE:', propValue, '|', 'RULE:', validationRule);
                }

                var ruleObj = rules[propName];


                var runRule = this.rulesApi[validationRule] || this.customRules[validationRule];
                // console.log('runRule name:', validationRule, isUndefined(runRule));
                // console.log('runRule function:', runRule)
                if (isUndefined(runRule)) {
                    console.error('Error detected during validation: Validation Config Error: Rule not defined: PROP:', propName, '|', 'RULE:', validationRule);
                } else
                if (typeof runRule !== 'function') {
                    console.error('Error detected during validation: Validation Config Error: Rule is defined but is not a function: PROP:', propName, '|', 'RULE:', validationRule);
                } else {
                    runRule(validateThis, propName, ruleObj, this);
                }

                // For fields with multiple rules: Report on just the FIRST rule not validated.
                // if (this.rulesApi.errorFound) {
                if (this.errorFound) {
                    break;
                }

            }
        })
    },




    // >>>>> MAIN API <<<<<<<<< ----------------------------------------

    getValidTypes: function () {
        return validTypes;
    },

    // validateThis obj, rules obj
    validate: function (validateThis, rules) {
        this.resetResults(); // Start with fresh results (so there's result data from previous run(s) of validate)
        this.started = true;
        this.validateViaRules(validateThis, rules);
        // this.setErrors(this.rulesApi.errors);
        this.completed = true;
    },

    getResult: function () {
        return {
            started: this.started,
            completed: this.completed,
            errorMsgs: this.getErrors()
        }
    },

    validationPassed: function () {
        if (!this.started) {
            this.addError('Validator Alert', 'Validator Alert', 'Validate method not called!');
            return false;
        }
        return this.hasErrors() ? false : true;
    },

    getErrors: function () {
        return this.errorMsgs;
    },


    // param: error : An element (type array) of the errorMsgs array: Prop name is first element of the error array
    getErrorProp: function (error) {
        return error[0]
    },

    // param: error : An element (type array) of the errorMsgs array: Property label is 2nd element of the error array
    getErrorPropLabel: function (error) {
        return error[1]
    },

    // param: error : An element (type array) of the errorMsgs array: Error message is 3rd element of the error array
    getErrorMsg: function (error) {
        return error[2]
    },


    hasErrors: function () {
        return this.getErrors().length;
    },

    clearErrors: function () {
        this.errorMsgs = [];
    },

    resetResults: function () {
        this.clearErrors();
        this.started = false;
        this.completed = false;
    }

}


function newValidator() {
    return Object.create(Validator);
}


export {
    newValidator
};

// Note: Great rules list here:
// https://logaretm.github.io/vee-validate/guide/rules.html